/*
 * @Date: 2022-04-20 17:15:44
 * @LastEditTime: 2022-05-27 10:26:20
 * @Description: file content
 */
import axios from 'axios';
import qs from 'qs';
import Vue from 'vue';
import detectApp from './detect-app';

const service = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Cache-Control': 'no-cache',
  },
});

service.interceptors.request.use(config => {
  const { method, headers } = config;

  if (
    method.toUpperCase() === 'POST' &&
    headers['Content-Type'] === 'application/x-www-form-urlencoded'
  ) {
    config.data = qs.stringify(config.data);
  }
  return config;
});

service.interceptors.response.use(
  response => response.data,
  error => {
    const { response = {} } = error;
    const { status, data = {}, statusText } = response;
    const errorMsg = data.error_msg || statusText;

    if (status === 401) {
      if (detectApp.isFromCY()) {
        window.location.href = `${window.location.origin}/v-m-mall/app-login/#OPEN_NEW_WIN`;
      } else {
        window.location.href = `${
          window.location.origin
        }/cooperation/wap/quick_login/?next=${encodeURI(window.location.href)}`;
      }
      return Promise.resolve({});
    }
    Vue.prototype.$toast(errorMsg || '出错了~');

    return Promise.reject(error);
  }
);

export default service;
